<template>
  <b-modal
    title="Novo grupo"
    :visible="show"
    hide-footer
    no-close-on-backdrop
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <b-overlay :show="loading" opacity="0.99">
      <b-form @submit.prevent="evOnSubmit">
        <warning-required-fields />
        <errors-messages :errors="errors" />
        <b-row>
          <b-col>
            <label-required-field label="Nome" />
            <b-input ref="autofocus" v-model="name" />
          </b-col>
        </b-row>
        <b-row align-h="end">
          <b-col cols="auto">
            <v-btn class="v-primary ml-1" @click="show = false">
              <v-icon class="mr-1">mdi-arrow-left</v-icon>
              VOLTAR
            </v-btn>
            <v-btn type="submit" class="v-success ml-1">
              <v-icon class="mr-1">mdi-check</v-icon>
              SALVAR
            </v-btn>
          </b-col>
        </b-row>
      </b-form>
    </b-overlay>
  </b-modal>
</template>

<script>
import toast from "../../components/ToastNotification";
import api from "../../services/api";
import ErrorsMessages from "../components/ErrorsMessages.vue";
import LabelRequiredField from "../components/LabelRequiredField.vue";
import WarningRequiredFields from "../components/WarningRequiredFields.vue";

export default {
  name: "NewGroup",
  components: {
    LabelRequiredField,
    ErrorsMessages,
    WarningRequiredFields,
  },
  props: {
    toggle: Boolean,
  },
  data: () => ({
    errors: [],

    show: false,
    loading: false,

    name: "",
  }),
  watch: {
    toggle: function () {
      this.show = true;
    },
  },
  methods: {
    async evOnShow() {
      this.errors = [];
      this.name = "";
    },
    async evOnShown() {
      this.$refs.autofocus.focus();
    },
    async evOnHide() {
      this.show = false;
    },

    async evOnSubmit() {
      this.loading = true;

      try {
        const data = { name: this.name };
        const response = await api.post(
          "/admin/rest-home/default/permission/group",
          data
        );
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.show = false;
          toast(message, "success");
          this.$emit("created");
        }
      } catch (error) {
        console.log(error);
      }

      this.loading = false;
    },
  },
};
</script>

<style>
</style>